'use client';

import { Box, Chip, IconButton, InputAdornment, InputLabel, MenuItem, OutlinedInput, Select } from '@mui/material';
import { ClearIcon } from '@mui/x-date-pickers';
import React, { Dispatch, FC, SetStateAction } from 'react';

const integrationOptions = [
	{
		display: 'Spothero',
		value: 'SPOTHERO',
	},
	{
		display: 'Spaces',
		value: 'SPACES',
	},
];

export const IntegrationSelect: FC<{
	integrations: string[];
	setIntegrations: Dispatch<SetStateAction<string[]>>;
}> = ({ integrations, setIntegrations }) => (
	<>
		<InputLabel>Integrations</InputLabel>
		<Select
			sx={{ width: '100%' }}
			placeholder='Integrations'
			multiple
			value={integrations}
			onChange={(e) => {
				setIntegrations(e.target.value as string[]);
			}}
			input={<OutlinedInput />}
			renderValue={(selectedIntegrations) => (
				<Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
					{selectedIntegrations.map((integration) => (
						<Chip key={integration} label={integration} />
					))}
				</Box>
			)}
			endAdornment={
				<InputAdornment position='end' sx={{ position: 'absolute', right: '1em', opacity: 0.6 }}>
					<IconButton
						onClick={() => {
							setIntegrations([]);
						}}
					>
						<ClearIcon />
					</IconButton>
				</InputAdornment>
			}
		>
			{integrationOptions.map(({ display, value }) => (
				<MenuItem key={display} value={value}>
					{display}
				</MenuItem>
			))}
		</Select>
	</>
);
